export function initAccordion($) {
  /* ========================================================================= \
  **  === ACCORDION                                                        *| 
  \ ========================================================================= */

  // Mécanique accordéons
  // $('.accordion--row-actions, .accordion--row-content').on('click', function(){
  //   let detailsHeightInner = $(this).siblings('.accordion--row-description').outerHeight()
  //   $(this).parent().toggleClass('is-active');
  //   console.log(detailsHeightInner)
  // })
  $('.accordion--element').on('click', function() {
    let detailsHeightInner = $(this).find('.accordion--details .row').outerHeight()
    if($(this).is('.is-active')) {
      $(this).removeClass('is-active');
    } else {
      $("body").get(0).style.setProperty("--accordion-height", detailsHeightInner + 'px');
      $('.accordion--element').removeClass('is-active');
      $(this).addClass('is-active');
    }
  });


  if(window.location.href.indexOf('#recrutement') > -1) {
    if($('.accordion').length) {
      $('html, body').animate({
        scrollTop: $('.accordion').siblings('.title-text').last().offset().top - 200
      });
    }
  }
  // Equivalent comportement slick slider pour déterminer la hauteur max de mega-accordion (enfants en absolute -> calcul mathématique)
  // if($('.accordion').length){
  //   let megaAccordionMaxHeight = 500;
  //   $('.accordion--row-description').each(function(){
  //     console.log($(this).height())
  //     $(this).height() > megaAccordionMaxHeight ? megaAccordionMaxHeight = $(this).height() : '';
  //     $(this).css('min-height', megaAccordionMaxHeight + 140);
  //   })
  // }
}
